export default {
    unit: 8,
    palette: {
        primary: '#1890FF',
        black: '#252c32',
    },
    breakpoint: {
        xxl: 1600,
        xl: 1200,
        lg: 992,
        md: 768,
        sm: 576,
    },
};
